export const PHONE_NUMBER = 'phoneNumber'
export const NAME = 'name'
export const FIRST_NAME = 'first-name'
export const LAST_NAME = 'last-name'

export const PHONE_NUMBER_PLACEMENT = 'user-profile-phone-number-form'

export const DELETE_WARNING_MODAL_TITLE =
    'Are you sure you want to delete your Fictiv account?'
export const DELETE_WARNING_MODAL_BUTTON_TEXT = 'Delete account'

const NAME_MIN = 1
const NAME_MAX = 64
const PHONE_NUMBER_MIN = 7
const PHONE_NUMBER_MAX = 16

export const NAME_RULES = [
    {
        required: true,
        message: `Name must be minimum ${NAME_MIN} characters.`,
    },
    {
        max: NAME_MAX,
        message: `Name cannot exceed ${NAME_MAX} characters`,
    },
]

export const PHONE_NUMBER_RULES = [
    {
        required: true,
        message: `Phone number required`,
    },
    {
        min: PHONE_NUMBER_MIN,
        message: `Phone number must be minimum ${PHONE_NUMBER_MIN} characters.`,
    },
    {
        max: PHONE_NUMBER_MAX,
        message: `Phone number cannot exceed ${PHONE_NUMBER_MAX} characters`,
    },
]
